'use strict';

var _ = require('lodash');
function ContributingFBGsGridController($scope, BrushSelectionFilter) {
  $scope.gridId = 'contributing-fbgs';
  $scope.refreshData = function () {
    $scope.$broadcast('grid:dataChanged');
  };
  $scope.gridRowSelected = function (rows) {
    var filterKeysFromRows = getFilterKeys(rows);
    return createBrushFilter(filterKeysFromRows);
  };
  function createBrushFilter(filterKeysFromRows) {
    return new BrushSelectionFilter('fbgs-grid', [{
      fareBasisGroups: filterKeysFromRows.fareBasisGroups,
      classes: filterKeysFromRows.classes
    }]);
  }
  function getFilterKeys(rows) {
    return {
      classes: _.chain(rows).map('className').uniq().value(),
      fareBasisGroups: _.chain(rows).map(function (row) {
        return [row.fareBasisGroup, row.className].join(':');
      }).value()
    };
  }
}
ContributingFBGsGridController.$inject = ['$scope', 'BrushSelectionFilterFactory'];
module.exports = ContributingFBGsGridController;